<template>
  <div v-if="shouldShowSelector" class="reserva-servicios-seleccion mb-10">
    <div
      class="header-card header-container mb-10 d-flex justify-content-between align-items-center"
      @click="toggleHeaderCollapse">
      <div class="header-content d-flex align-items-center">
        <img
          v-if="agrupacionServicios.icono"
          height="36"
          :src="agrupacionServicios.icono"
          :alt="agrupacionServicios.nombre"
          class="me-2 agrupacion-icon" />
        <i v-else :class="serviciosMetaData.icono" class="me-2 text-primary" />
        <span class="text-primary fw-semibold fs-19 translate">{{ agrupacionServicios.nombre }}</span>
        <InfoIcon
          v-if="hasNominalServicios"
          class="custom-svgInfo"
          size="12px"
          :message-info="t('servicios.tooltipMessageIsNominal')" />
      </div>
      <CustomIcon :icon="headerCollapsed ? arrowDownIcon : arrowUpIcon" size="24px" class="text-primary" />
    </div>

    <div v-if="!headerCollapsed">
      <div>
        <div v-for="grupo in serviciosAgrupados" :key="grupo.id" class="grupo-firstfilter">
          <div v-if="grupo.name" class="grupo-titulo-header grupo-header mb-10" @click="toggleGrupoCollapse(grupo.id)">
            <div class="grupo-header-content d-flex align-items-center justify-content-between">
              <span class="text-primary fw-semibold fs-14">{{ grupo.name }}</span>
              <CustomIcon
                :icon="isGrupoCollapsed(grupo.id) ? arrowDownIcon : arrowUpIcon"
                size="24px"
                class="text-primary" />
            </div>
          </div>
          <template v-if="!isGrupoCollapsed(grupo.id)">
            <div v-for="servicio in grupo.servicios" :key="servicio.id" class="mb-2 mb-mobile-5">
              <div class="servicio-card" :class="getServicioClasses(servicio)" @click="selectServicio(servicio)">
                <div
                  class="servicio-card-content servicio-main-content d-flex justify-content-between align-items-center">
                  <div class="servicio-content flex-grow-1">
                    <div class="servicio-info-mobile servicio-info-container d-flex align-items-center flex-wrap">
                      <!-- Desktop -->
                      <div class="servicio-title-row d-md-flex d-none">
                        <span class="text-primary translate fs-16" :class="{ 'fw-semibold': isSelected(servicio) }">
                          {{ getServicioName(servicio) }}
                        </span>
                        <small v-if="!servicio.nulo" class="servicio-fechas fs-13">
                          ({{ $t('general.del') }} {{ formatDateDDmm(servicio.fechaInicio) }} {{ $t('general.al') }}
                          {{ formatDateDDmm(servicio.fechaFin) }})
                        </small>
                        <a
                          v-if="servicio.infoExtra"
                          href="#"
                          class="info-extra-link fs-13 text-decoration-underline"
                          data-bs-toggle="modal"
                          :data-bs-target="`#infoExtraModal${servicio.id}`"
                          @click.stop>
                          + {{ $t('general.info') }}
                        </a>
                      </div>

                      <!-- Mobile -->
                      <div class="d-md-none w-100">
                        <div class="d-flex align-items-center gap-2 mb-1">
                          <span class="text-primary translate fs-16" :class="{ 'fw-semibold': isSelected(servicio) }">
                            {{ getServicioName(servicio) }}
                          </span>
                          <a
                            v-if="servicio.infoExtra"
                            href="#"
                            class="info-extra-link fs-13 text-decoration-underline"
                            data-bs-toggle="modal"
                            :data-bs-target="`#infoExtraModal${servicio.id}`"
                            @click.stop>
                            + {{ $t('general.info') }}
                          </a>
                        </div>

                        <div v-if="!servicio.nulo" class="mb-1">
                          <small class="servicio-fechas fs-13">
                            ({{ $t('general.del') }} {{ formatDateDDmm(servicio.fechaInicio) }} {{ $t('general.al') }}
                            {{ formatDateDDmm(servicio.fechaFin) }})
                          </small>
                        </div>
                      </div>
                    </div>
                    <!-- Mobile -->
                    <div
                      v-if="servicio.descripcion"
                      class="servicio-descripcion fs-13 mt-1 d-md-none text-primary translate">
                      {{ servicio.descripcion }}
                    </div>

                    <!-- Desktop -->
                    <div
                      v-if="servicio.descripcion"
                      class="servicio-descripcion fs-13 mt-1 d-none d-md-block text-primary translate">
                      {{ servicio.descripcion }}
                    </div>

                    <a
                      v-if="isSelected(servicio) && !servicio.nulo && agrupacionServicios.tipo === SEGURO_SELECTOR"
                      href="#"
                      class="info-extra-link fs-13 text-decoration-underline mt-1"
                      @click.stop="showInsurancePolicy(servicio.id)">
                      {{ $t('servicios.seguro.verPoliza') }}
                    </a>
                  </div>

                  <div class="servicio-right-section d-flex align-items-center">
                    <!-- Desktop -->
                    <div
                      v-if="isSelected(servicio) && !servicio.nominal && selectedServicio"
                      class="cantidad-control me-3 d-none d-md-block"
                      @click.stop>
                      <InputSelectorCantidad
                        :disabled="!isServicioContratable(reserva, selectedServicio.servicio)"
                        :count="selectedServicio.cantidad"
                        :min-count="
                          isServicioDescontratable(reserva, selectedServicio.servicio)
                            ? 1
                            : selectedServicio.cantidadOriginal
                        "
                        :max-count="getMaxCantidad(selectedServicio.servicio)"
                        :real-max-count="calculaMaxRealCantidadForServicio(selectedServicio.servicio)"
                        :is-agotado="!isSelectable(selectedServicio.servicio)"
                        @update-count="updateCantidad" />
                    </div>

                    <div class="servicio-precio-estado">
                      <template v-if="!isSelectable(servicio)">
                        <span class="badge bg-danger fs-13">{{ $t('general.agotado') }}</span>
                      </template>
                      <template v-else>
                        <div class="precio-estado-container d-flex align-items-center">
                          <template v-if="servicio.precio === 0 && !servicio.nulo && isSelected(servicio)">
                            <span class="text-primary me-2 fs-13">{{ $t('general.incluido') }}</span>
                          </template>
                          <template v-else>
                            <span class="text-primary fs-16 fw-semibold me-2">
                              <template v-if="servicio.precio > 0">+</template>{{ servicio.precio
                              }}{{ agenciaStore.getCurrency }}
                            </span>
                          </template>
                          <div
                            v-if="isSelected(servicio)"
                            class="check-circle d-flex align-items-center justify-content-center">
                            <i class="fa-solid fa-check"></i>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>

                <!-- Mobile -->
                <div
                  v-if="isSelected(servicio) && !servicio.nominal && selectedServicio"
                  class="cantidad-control-mobile cantidad-container-mobile d-block d-md-none d-flex justify-content-end"
                  @click.stop>
                  <InputSelectorCantidad
                    :disabled="!isServicioContratable(reserva, selectedServicio.servicio)"
                    :count="selectedServicio.cantidad"
                    :min-count="
                      isServicioDescontratable(reserva, selectedServicio.servicio)
                        ? 1
                        : selectedServicio.cantidadOriginal
                    "
                    :max-count="getMaxCantidad(selectedServicio.servicio)"
                    :real-max-count="calculaMaxRealCantidadForServicio(selectedServicio.servicio)"
                    :is-agotado="!isSelectable(selectedServicio.servicio)"
                    @update-count="updateCantidad" />
                </div>
              </div>
            </div>
          </template>
        </div>

        <div v-for="servicio in serviciosSinAgrupar" :key="servicio.id" class="mb-2 mb-mobile-5">
          <div class="servicio-card" :class="getServicioClasses(servicio)" @click="selectServicio(servicio)">
            <div class="servicio-card-content servicio-main-content d-flex justify-content-between align-items-center">
              <div class="servicio-content flex-grow-1">
                <div class="servicio-info-mobile servicio-info-container d-flex align-items-center flex-wrap">
                  <!-- Desktop -->
                  <div class="servicio-title-row d-md-flex d-none">
                    <span class="text-primary translate fs-16" :class="{ 'fw-semibold': isSelected(servicio) }">
                      {{ getServicioName(servicio) }}
                    </span>
                    <small v-if="!servicio.nulo" class="servicio-fechas fs-13">
                      ({{ $t('general.del') }} {{ formatDateDDmm(servicio.fechaInicio) }} {{ $t('general.al') }}
                      {{ formatDateDDmm(servicio.fechaFin) }})
                    </small>
                    <a
                      v-if="servicio.infoExtra"
                      href="#"
                      class="info-extra-link fs-13 text-decoration-underline"
                      data-bs-toggle="modal"
                      :data-bs-target="`#infoExtraModal${servicio.id}`"
                      @click.stop>
                      + {{ $t('general.info') }}
                    </a>
                  </div>

                  <!-- Mobile -->
                  <div class="d-md-none w-100">
                    <div class="d-flex align-items-center gap-2 mb-1">
                      <span class="text-primary translate fs-16" :class="{ 'fw-semibold': isSelected(servicio) }">
                        {{ getServicioName(servicio) }}
                      </span>
                      <a
                        v-if="servicio.infoExtra"
                        href="#"
                        class="info-extra-link fs-13 text-decoration-underline"
                        data-bs-toggle="modal"
                        :data-bs-target="`#infoExtraModal${servicio.id}`"
                        @click.stop>
                        + {{ $t('general.info') }}
                      </a>
                    </div>

                    <div v-if="!servicio.nulo" class="mb-1">
                      <small class="servicio-fechas fs-13">
                        ({{ $t('general.del') }} {{ formatDateDDmm(servicio.fechaInicio) }} {{ $t('general.al') }}
                        {{ formatDateDDmm(servicio.fechaFin) }})
                      </small>
                    </div>
                  </div>
                </div>
                <!-- Mobile -->
                <div
                  v-if="servicio.descripcion"
                  class="servicio-descripcion fs-13 mt-1 d-md-none text-primary translate">
                  {{ servicio.descripcion }}
                </div>

                <!-- Desktop -->
                <div
                  v-if="servicio.descripcion"
                  class="servicio-descripcion fs-13 mt-1 d-none d-md-block text-primary translate">
                  {{ servicio.descripcion }}
                </div>

                <a
                  v-if="isSelected(servicio) && !servicio.nulo && agrupacionServicios.tipo === SEGURO_SELECTOR"
                  href="#"
                  class="info-extra-link fs-13 text-decoration-underline mt-1"
                  @click.stop="showInsurancePolicy(servicio.id)">
                  {{ $t('servicios.seguro.verPoliza') }}
                </a>
              </div>

              <div class="servicio-right-section d-flex align-items-center">
                <!-- Desktop -->
                <div
                  v-if="isSelected(servicio) && !servicio.nominal && selectedServicio"
                  class="cantidad-control me-3 d-none d-md-block"
                  @click.stop>
                  <InputSelectorCantidad
                    :disabled="!isServicioContratable(reserva, selectedServicio.servicio)"
                    :count="selectedServicio.cantidad"
                    :min-count="
                      isServicioDescontratable(reserva, selectedServicio.servicio)
                        ? 1
                        : selectedServicio.cantidadOriginal
                    "
                    :max-count="getMaxCantidad(selectedServicio.servicio)"
                    :real-max-count="calculaMaxRealCantidadForServicio(selectedServicio.servicio)"
                    :is-agotado="!isSelectable(selectedServicio.servicio)"
                    @update-count="updateCantidad" />
                </div>

                <div class="servicio-precio-estado">
                  <template v-if="!isSelectable(servicio)">
                    <span class="badge bg-danger fs-13">{{ $t('general.agotado') }}</span>
                  </template>
                  <template v-else>
                    <div class="precio-estado-container d-flex align-items-center">
                      <template v-if="servicio.precio === 0 && !servicio.nulo && isSelected(servicio)">
                        <span class="text-primary me-2 fs-13">{{ $t('general.incluido') }}</span>
                      </template>
                      <template v-else>
                        <span class="text-primary fs-16 fw-semibold me-2">
                          <template v-if="servicio.precio > 0">+</template>{{ servicio.precio
                          }}{{ agenciaStore.getCurrency }}
                        </span>
                      </template>
                      <div
                        v-if="isSelected(servicio)"
                        class="check-circle d-flex align-items-center justify-content-center">
                        <i class="fa-solid fa-check"></i>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>

            <!-- Mobile -->
            <div
              v-if="isSelected(servicio) && !servicio.nominal && selectedServicio"
              class="cantidad-control-mobile cantidad-container-mobile d-block d-md-none d-flex justify-content-end"
              @click.stop>
              <InputSelectorCantidad
                :disabled="!isServicioContratable(reserva, selectedServicio.servicio)"
                :count="selectedServicio.cantidad"
                :min-count="
                  isServicioDescontratable(reserva, selectedServicio.servicio) ? 1 : selectedServicio.cantidadOriginal
                "
                :max-count="getMaxCantidad(selectedServicio.servicio)"
                :real-max-count="calculaMaxRealCantidadForServicio(selectedServicio.servicio)"
                :is-agotado="!isSelectable(selectedServicio.servicio)"
                @update-count="updateCantidad" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-for="servicio in availableServicios" :key="`modal-${servicio.id}`">
      <div
        v-if="servicio.infoExtra"
        :id="`infoExtraModal${servicio.id}`"
        class="modal fade"
        tabindex="-1"
        :aria-labelledby="`infoExtraModalLabel${servicio.id}`"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 :id="`infoExtraModalLabel${servicio.id}`" class="modal-title text-primary translate">
                {{ getServicioName(servicio) }}
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div v-sanitize-html="servicio.infoExtra" class="translate"></div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
  import { ref, computed, onBeforeMount, reactive } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useRoute } from 'vue-router';
  import { informacionHabitacion } from '@/store_pinia/informacionHabitacion';
  import { agenciaStoreModule } from '@/store_pinia/agencia';
  import {
    getCategoriasServiciosMetaData,
    isServicioContratable,
    isServicioDescontratable,
  } from '@/helpers/serviciosUtils';
  import { formatDateDDmm } from '@/helpers/dateUtiles';
  import { toRawDeep } from '@/helpers/reactivityUtils';
  import InfoIcon from '@/components/Icons/InfoIcon.vue';
  import InputSelectorCantidad from '@/components/inputs/InputSelectorCantidad';
  import CustomIcon from '@/components/CustomIcon.vue';
  import arrowDownIcon from '@/assets/icons/arrow_down.svg';
  import arrowUpIcon from '@/assets/icons/arrow_up.svg';
  import ViajesGrupoApiService from '@/services/api/skiandnight/ViajesGrupoApiService';
  import { SEGURO_SELECTOR } from '@/constants/selectService';

  const props = defineProps({
    agrupacionServicios: { type: Object, default: null },
    idxReserva: { type: Number, default: null },
  });

  const emits = defineEmits(['servicioSeleccionado']);

  const { t } = useI18n();
  const viajeId = useRoute().params.viajeId;
  const storeHabitacion = informacionHabitacion();
  const agenciaStore = agenciaStoreModule();

  const selectedServicio = ref(null);
  const collapsedGrupos = reactive({});
  const headerCollapsed = ref(false);

  const hasNominalServicios = props.agrupacionServicios.servicios.some(s => s.nominal && !s.nulo);
  const serviciosPaqueteBasico = props.agrupacionServicios.servicios.filter(s => s.paqueteBasico);
  const serviciosPaqueteBasicoByGrupo = new Map();

  const serviciosMetaData = getCategoriasServiciosMetaData().find(
    ({ selector }) => selector === props.agrupacionServicios.tipo
  );

  const reserva = computed(() => storeHabitacion.getReservaByIdx(props.idxReserva));

  const availableServicios = computed(() =>
    props.agrupacionServicios.servicios
      .filter(s => !s.nulo && (s.activo || isSelected(s)))
      .sort((a, b) => a.precio - b.precio)
  );

  const serviciosAgrupados = computed(() => {
    const servicios = availableServicios.value;

    const serviciosConFiltros = servicios.filter(s => s.firstFilter?.id);
    if (serviciosConFiltros.length === 0) {
      return [];
    }

    const grupos = {};
    serviciosConFiltros.forEach(servicio => {
      const key = servicio.firstFilter.id;
      const name = servicio.firstFilter.nombre;

      if (!grupos[key]) {
        grupos[key] = { id: key, name, servicios: [] };
      }
      grupos[key].servicios.push(servicio);
    });

    return Object.values(grupos);
  });

  const serviciosSinAgrupar = computed(() => {
    const servicios = availableServicios.value;
    return servicios.filter(s => !s.firstFilter?.id);
  });

  const shouldShowSelector = computed(() => {
    if (props.agrupacionServicios.servicios.length === 1) {
      const servicio = props.agrupacionServicios.servicios[0];
      if (servicio.paqueteBasico && servicio.obligatorio && servicio.nominal) {
        return false;
      }
    }
    return (
      (selectedServicio.value && !selectedServicio.value.servicio?.nulo) ||
      props.agrupacionServicios.servicios.some(s => !s.nulo && s.activo)
    );
  });

  serviciosPaqueteBasico.forEach(servicio => {
    const key = servicio.firstFilter?.id;
    serviciosPaqueteBasicoByGrupo.set(key, servicio);
  });

  function isSelected(servicio) {
    return selectedServicio.value?.servicio?.id === servicio.id;
  }

  function isSelectable(servicio) {
    return (
      isServicioContratable(reserva.value, servicio) &&
      (isSelected(servicio) || servicio.nulo || getMaxCantidad(servicio) > 0)
    );
  }

  function getServicioClasses(servicio) {
    return {
      selected: isSelected(servicio),
      disabled: !isSelectable(servicio) && !isSelected(servicio),
      agotado: !isSelectable(servicio) && !servicio.nulo,
      'no-deselectable': isSelected(servicio) && (servicio.paqueteBasico || servicio.obligatorio),
    };
  }

  function getServicioName(servicio) {
    let name = servicio.nombre;
    if (servicio.secondFilter?.nombre) {
      name += ` (${servicio.secondFilter.nombre})`;
    }
    return name;
  }

  function toggleHeaderCollapse() {
    headerCollapsed.value = !headerCollapsed.value;
  }

  function toggleGrupoCollapse(grupoId) {
    collapsedGrupos[grupoId] = !collapsedGrupos[grupoId];
  }

  function isGrupoCollapsed(grupoId) {
    return collapsedGrupos[grupoId];
  }

  function calculaMaxRealCantidadForServicio(servicio) {
    let cantidadActual = 0;
    const servicioCategorizado = findServicioCategorizado(servicio.id);

    if (selectedServicio.value && selectedServicio.value.servicio) {
      if (servicio.cuposMetasId?.some(id => selectedServicio.value.servicio.cuposMetasId?.includes(id))) {
        cantidadActual = selectedServicio.value.cantidad;
      }
    }

    return cantidadActual + servicioCategorizado.numCupos;
  }

  function getMaxCantidad(servicio) {
    return Math.min(calculaMaxRealCantidadForServicio(servicio), 10);
  }

  function getServicioPaqueteBasicoInSameGrupo(servicio) {
    const key = servicio.firstFilter?.id;
    return serviciosPaqueteBasicoByGrupo.get(key);
  }

  function selectServicio(servicio) {
    if (!isSelectable(servicio)) return;

    const servicioPaqueteBasico = getServicioPaqueteBasicoInSameGrupo(servicio);

    if (isSelected(servicio)) {
      if (servicio.paqueteBasico) return;

      if (servicioPaqueteBasico) {
        updateSelectedServicio(servicioPaqueteBasico);
      } else {
        deselectAll();
      }
      return;
    }

    updateSelectedServicio(servicio);
  }

  function updateSelectedServicio(servicio) {
    const servicioToSelect = toRawDeep(findServicioCategorizado(servicio.id));
    servicioToSelect.justSelected = true;

    const oldServicio = selectedServicio.value?.servicio;
    const oldCantidad = selectedServicio.value?.cantidad;
    const servicioPaqueteBasico = getServicioPaqueteBasicoInSameGrupo(servicioToSelect);

    selectedServicio.value = {
      servicio: servicioToSelect,
      oldServicio: oldServicio,
      cantidad: 1,
      oldCantidad: 1,
      cantidadOriginal: 1,
      categoriaPaqueteBasico: servicioPaqueteBasico !== null,
      servicioPB: servicioPaqueteBasico,
    };

    saveToStore();

    if (!servicioToSelect.nulo) {
      storeHabitacion.decrementCupoServicios(servicioToSelect);
    }
    if (oldServicio && !oldServicio.nulo) {
      storeHabitacion.incrementCupoServicios(oldServicio, oldCantidad);
    }
  }

  function deselectAll() {
    const oldServicio = selectedServicio.value?.servicio;
    const oldCantidad = selectedServicio.value?.cantidad;

    if (oldServicio && !oldServicio.nulo) {
      storeHabitacion.incrementCupoServicios(oldServicio, oldCantidad);
    }

    selectedServicio.value = null;

    if (reserva.value?.serviciosWithCantidad) {
      delete reserva.value.serviciosWithCantidad[props.agrupacionServicios.id];
      emits('servicioSeleccionado', props.idxReserva, props.agrupacionServicios.id, null);
    }
  }

  function updateCantidad(newCantidad) {
    if (!selectedServicio.value) return;

    selectedServicio.value.cantidad = newCantidad;
    saveToStore();

    if (selectedServicio.value.cantidad < selectedServicio.value.oldCantidad) {
      storeHabitacion.incrementCupoServicios(selectedServicio.value.servicio);
    } else {
      storeHabitacion.decrementCupoServicios(selectedServicio.value.servicio);
    }
    selectedServicio.value.oldCantidad = newCantidad;
  }

  function saveToStore() {
    if (!selectedServicio.value) return;

    storeHabitacion.addServicioToReserva(
      props.idxReserva,
      selectedServicio.value.servicio,
      selectedServicio.value.cantidad
    );
    emits('servicioSeleccionado', selectedServicio.value);
  }

  function showInsurancePolicy(servicioId) {
    const newWindow = window.open();
    ViajesGrupoApiService.getPolizaSeguroViaje(viajeId, servicioId).then(res => {
      const file = new Blob([res], { type: 'application/pdf' });
      newWindow.location = URL.createObjectURL(file);
    });
  }

  function findServicioCategorizado(servicioId) {
    return props.agrupacionServicios.servicios.find(s => s.id === servicioId);
  }

  function init() {
    const existingServicio = reserva.value?.serviciosWithCantidad[props.agrupacionServicios.id];
    const servicioPaqueteBasico = serviciosPaqueteBasico[0];

    if (!existingServicio) {
      let servicio = props.agrupacionServicios.servicios.reduce((acc, s) => {
        if ((s.paqueteBasico && s.numCupos > 0) || (acc == null && s.nulo)) {
          return s;
        }
        return acc;
      }, null);

      if (!servicio) {
        servicio = props.agrupacionServicios.servicios
          .filter(s => s.activo && s.numCupos > 0)
          .reduce((acc, s) => (acc == null || s.precio < acc.precio ? s : acc), null);
      }

      if (servicio) {
        selectedServicio.value = {
          servicio: servicio,
          oldServicio: servicio,
          cantidad: 1,
          oldCantidad: 1,
          cantidadOriginal: 1,
          categoriaPaqueteBasico: servicioPaqueteBasico !== null,
          servicioPB: servicioPaqueteBasico,
        };

        if (!servicio.nulo) {
          storeHabitacion.decrementCupoServicios(servicio);
        }
        saveToStore();
      }
    } else {
      const currentServicio = findServicioCategorizado(existingServicio.servicio.id);
      selectedServicio.value = {
        servicio: currentServicio,
        oldServicio: currentServicio,
        cantidad: existingServicio.cantidad,
        oldCantidad: existingServicio.cantidad,
        cantidadOriginal: existingServicio.cantidad,
        categoriaPaqueteBasico: servicioPaqueteBasico !== null,
        servicioPB: servicioPaqueteBasico,
      };
      saveToStore();
    }
  }

  onBeforeMount(() => {
    init();
  });
</script>

<style lang="scss" scoped>
  .reserva-servicios-seleccion {
    .header-card {
      background-color: rgba(var(--bs-light-rgb), 1);
      border-radius: var(--bs-border-radius-lg);
      border: 1px solid rgba(var(--bs-primary-rgb), 0.1);
      padding: 16px 20px;
      border-radius: var(--bs-border-radius-lg);
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        background-color: rgba(var(--bs-light-rgb), 0.8);
      }
    }

    .grupo-firstfilter {
      .grupo-titulo-header {
        background-color: rgba(var(--bs-light-rgb), 1);
        border-radius: var(--bs-border-radius-lg);
        padding: 12.5px 15px;
        cursor: pointer;
        transition: all 0.2s ease;
        margin-bottom: 10px;
        border: 1px solid rgba(var(--bs-primary-rgb), 0.1);

        &:hover {
          background-color: rgba(var(--bs-light-rgb), 0.8);
        }
      }
    }

    .custom-svgInfo {
      margin-left: 0.3rem;
    }

    .agrupacion-icon {
      width: 36px;
      height: 36px;
    }

    .servicio-card {
      padding: 15px;
      min-height: 63px;
      border: 1px solid #e0e0e0;
      border-radius: var(--bs-border-radius);
      cursor: pointer;
      transition: all 0.2s ease;

      .servicio-info-container {
        .servicio-title-row {
          gap: 10px;
        }
      }

      &:hover:not(.disabled) {
        border-color: var(--bs-primary);
        box-shadow: 0 2px 4px rgba(var(--bs-primary-rgb), 0.1);
      }

      &.selected {
        border-color: var(--bs-secondary);
        background-color: rgba(var(--bs-secondary-rgb), 0.1);
        border-width: 2px;
      }

      &.disabled {
        cursor: not-allowed;
        opacity: 0.6;
        background-color: #f8f9fa;
      }

      &.agotado {
        border-color: var(--bs-danger-rgb);
        background-color: rgba(var(--bs-danger-rgb), 0.05);
      }

      .servicio-content {
        .servicio-descripcion {
          line-height: 1.3;
        }
      }

      .cantidad-control {
        position: relative;
        z-index: 10;
      }

      .servicio-precio-estado {
        .check-circle {
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background-color: var(--bs-secondary);

          i {
            color: white;
            font-size: 8px;
          }
        }
      }
    }

    .servicio-fechas {
      color: rgba(var(--bs-primary-rgb), 0.8);
      line-height: 1.25;
    }

    .info-extra-link {
      color: var(--bs-primary) !important;

      &:hover {
        color: var(--bs-primary) !important;
        opacity: 0.8;
      }
    }
  }

  @media (max-width: 768px) {
    .reserva-servicios-seleccion {
      .mb-mobile-5 {
        margin-bottom: 5px !important;
      }

      .agrupacion-icon {
        width: 20px !important;
        height: 20px !important;
      }

      .servicio-card {
        .servicio-content {
          margin-right: 15px;
        }

        .cantidad-container-mobile {
          position: relative;
          z-index: 10;
        }
      }
    }
  }
</style>
